import { createAction, props } from '@ngrx/store';

import { IUser } from '../../core/interfaces/user.interface';

export const setLoggedInUser = createAction(
    '[User] Set Logged In User',
    props<{ user: IUser | null }>(),
);
